export default __webpack_public_path__ + "static/media/kobbari_mithai.45b4d39b.png";